function unwrapRefValue(value) {
  if (value && typeof value === "object" && "current" in value) {
    return value.current;
  } else {
    return value;
  }
}
export {
  unwrapRefValue
};
//# sourceMappingURL=unwrapRefValue.js.map
